import { render, staticRenderFns } from "./schemeManage.vue?vue&type=template&id=0207f416&scoped=true"
import script from "./schemeManage.vue?vue&type=script&lang=js"
export * from "./schemeManage.vue?vue&type=script&lang=js"
import style0 from "./schemeManage.vue?vue&type=style&index=0&id=0207f416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0207f416",
  null
  
)

export default component.exports